module.exports = __webpack_public_path__ + "static/media/balance-scale-right.d4f8b7e2.svg";